<template>
    <modal @modal-close="handleClose">

        <div class="modal-wrapper">

            <CloseButton @click="handleClose" />

            <div class="modal-content">
                <template v-if="shouldDisplayUserFilters">
                    <div class="mb-6 mt-3 flex items-center" @click="handleOwn">
                        <Checkbox :checked="temporaryFilters.own === 1" />
                        <label class="flex-1 ml-3 text-80">
                            {{ $t('Show only my done inspections') }}
                        </label>
                    </div>

                    <input-control :label="$t('Conducted by')">
                    <select
                            v-model="temporaryFilters.user" class="w-full form-select" :class="{'empty': temporaryFilters.user === null}">
                                <option :value="null">{{ $t('Select user') }}</option>
                                <option
                                    v-for="(userName, userId) in userFilterOptions"
                                    :value="parseInt(userId)">
                                        {{ userName }}
                                </option>
                        </select>
                    </input-control>
                </template>

                <input-control :label="$t('Site')">
                <select
                        v-model="temporaryFilters.site" class="w-full form-select" :class="{'empty': temporaryFilters.user === null}">
                            <option :value="null">{{ $t('Select site') }}</option>
                            <option
                                v-for="(siteName, siteId) in siteFilterOptions"
                                :value="parseInt(siteId)">
                                    {{ siteName }}
                            </option>
                    </select>
                </input-control>

                <input-control-date
                    v-model="temporaryFilters.from"
                    :label="$t('From (date)')"
                />

                <input-control-date
                    v-model="temporaryFilters.to"
                    :label="$t('To (date)')"
                    style="margin-bottom: 0;"
                />
            </div>

            <div class="modal-actions-outer-wrapper">
                <div class="modal-actions-inner-wrapper">
                <button
                    type="button"
                    class="w-full btn btn-default btn-primary w-full medium:w-auto mt-4 medium:mt-0"
                    @click.prevent="handleUpdate"
                    >
                    {{ $t('Save') }}
                </button>
                </div>
            </div>

        </div>

    </modal>
</template>

<script>
import InputControl from '@mobile/components/Form/InputControl';
import InputControlDate from '@/components/Form/InputControlDate';
import Checkbox from '@mobile/components/Checkbox';
import CloseButton from '@/components/Modals/CloseButton.vue';

export default {

    components: {
        Checkbox, InputControl, InputControlDate, CloseButton,
    },

    props: {
        filters: {
            type: Object,
            required: true,
        },
        siteFilterOptions: {
        	type: Object,
        },
        userFilterOptions: {
        	type: Object,
        },
    },

    data: () => ({
        temporaryFilters: {},
    }),

    computed: {
        shouldDisplayUserFilters() {
            return this.$store.getters['authentication/hasPermission']('view-all-inspections');
        },
    },

    created() {
        if (this.filters) {
            this.temporaryFilters = { ...this.temporaryFilters, ...JSON.parse(JSON.stringify(this.filters)) };
        }
    },


    methods: {
        handleClose() {
            this.$emit('close');
        },

        handleUpdate(event) {
            this.$emit('update', this.temporaryFilters);
            this.$emit('close');
        },

        handleOwn() {
        	console.log('own clicked', this.temporaryFilters);
        	if (this.temporaryFilters.own === 1) {
        		this.temporaryFilters.own = 0;
        	} else {
        		this.temporaryFilters.own = 1;
        	}
        },
    },


};
</script>
